export const convertVitalsValueToBaseValue = (value, currentUnitOfValue) => {
    switch (currentUnitOfValue) {
        case "kPa":
            return parseFloat(value) * 7.50062;
        case "psi":
            return parseFloat(value) * 51.7149;
        case "mmol/L":
            return parseFloat(value) * 18;
        case "°F":
            return (parseFloat(value) - 32) / 1.8;
        case "lbs":
            return parseFloat(value) * 0.45359237;
        default:
            return parseFloat(value);
    }
};

export const convertVitalsBaseValueToOrgLevelUnit = (value, currentUnitOfValue) => {
    switch (currentUnitOfValue) {
        case "kPa":
            return parseFloat(parseFloat(value) / 7.50062).toFixed(1);
        case "psi":
            return parseFloat(parseFloat(value) / 51.7149).toFixed(1);
        case "mmol/L":
            return parseFloat(parseFloat(value) / 18).toFixed(1);
        case "°F":
            return parseFloat((parseFloat(value) * 9) / 5 + 32).toFixed(1);
        case "lbs":
            return parseFloat(parseFloat(value) / 0.45359237).toFixed(1);
        default:
            return parseFloat(value).toFixed(1);
    }
};
